<template>
  <div class="table-responsive">
    <table class="table">
      <thead class="tw:text-left tw:text-sm tw:bg-zinc-50 tw:hidden tw:md:table-header-group">
        <tr>
          <th class="align-middle tw:text-left"></th>
          <th class="align-middle tw:text-left">{{ $t('Name') }}</th>
          <th class="align-middle tw:text-left">{{ $t('Entity') }}</th>
          <th class="align-middle tw:text-left">{{ $t('Type') }}</th>
          <th class="align-middle tw:text-left">{{ $t('Action') }}</th>
        </tr>
      </thead>
      <Sortable
        :list="items"
        item-key="id"
        tag="tbody"
        :options="{handle:'.draggable-handle'}"
        @end="updateOrder"
      >
        <template #item="{element: metafield, index}">
          <tr :key="metafield.id">
            <td style="width: 20px" class="align-middle">
             <span class="draggable-handle">
                <i class="fa fa-sort" aria-hidden="true"></i>
              </span>
            </td>
            <td class="align-middle">
              {{ metafield.name }}
            </td>
            <td class="align-middle">
              {{ metafield.model }}
            </td>
            <td class="align-middle">
              <Badge variant="zinc">
                {{ metafield.type }}
              </Badge>
            </td>
            <td>
              <Button as-child variant="outline" :disabled="!metafield.links?.edit" size="sm">
                <a :href="metafield.links.edit">
                  {{ $t('Edit') }}
                </a>
              </Button>
            </td>
          </tr>
        </template>
      </Sortable>
    </table>
  </div>
</template>

<script setup>
import { ref, toRefs, watch, onMounted } from 'vue';
import { Sortable } from "sortablejs-vue3";
import { displayDate } from '@/utils/date';
import axios from 'axios';
import { Button } from "@/shadcn/components/ui/button/index.js";
import { Badge } from "@/components/ui/badge/index.js";

// Props
const props = defineProps({
  metafields: {
    type: Array,
    required: true
  },
  updateOrderUrl: {
    type: String,
    required: true
  },
});

const items = ref(props.metafields);

watch(() => props.metafields, (newVal) => {
  items.value = newVal;
});

function updateOrder(event) {
  items.value.splice(event.newIndex, 0, items.value.splice(event.oldIndex, 1)[0]);
  axios.put(props.updateOrderUrl, {
    order: items.value.map((item) => item.id)
  })
  .catch(function (error) {
    alert(error);
  });
}

</script>

<style scoped>

</style>
